/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = (props) => (
  <a target={props.target} className={props.className} href={props.href} rel="noopener noreferrer" onClick={props.onClick}>
    {props.children}
  </a>
);
ExternalLink.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  target: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
ExternalLink.defaultProps = {
  onClick: () => {},
  target: '_blank',
};

export default ExternalLink;
